<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/engine/jiangxi/jx.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器江西工厂
                </div>
                <div class="manufacture-t2">
                    华东区域布局发动机生产基地，位于江西省上饶市，总占地面积84亩，2022年投产；<br />
                    主要生产EB、EN汽油发动机。工厂整体分四个车间：EN粗加车间、EN精加车间、EB机加车间、EB装试车间。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                机加车间
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                产线特点
                            </div>
                            <div class="destils">
                                规划粗加、精加共计五条生产线，涵盖缸体、缸盖、曲轴三大自制件。<br />
                                全线采用日本YNC、法国柯马、德国兰蒂斯等高精尖加工设备，各设备均通过信息化手段实现加工信息记录和质量追溯，线体节拍128S，自动化率：大于76%。
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/jiangxi/jx1-1.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                装试车间
            </div>
            <div class="page-t2">
                恒温无尘全封闭车间，设定EB、EN两大机型混线生产，主要涵盖拧紧、压装、试漏、涂胶、热试五大工艺，防错覆盖率95.1%，拧紧设备采用阿特拉斯拧紧轴实现全自动拧紧，全线配备关键机器人（KUKA）15台，并采用信息化集成AMS系统全工况模拟整车状态，可实现发动机装配各环节数据信息追溯
            </div>
        </div>

        <!-- <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/jiangxi/jx2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                产线特点
                            </div>
                            <div class="destils">
                                恒温无尘全封闭车间，设定EB、EN两大机型混线生产，主要涵盖拧紧、压装、试漏、涂胶、热试五大工艺，防错覆盖率95.1%，拧紧设备采用阿特拉斯拧紧轴实现全自动拧紧，全线配备关键机器人（KUKA）15台，并采用信息化集成AMS系统全工况模拟整车状态，可实现发动机装配各环节数据信息追溯
                            </div>
                        </div>
                    </div>

                    
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div> -->

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器江西工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/jiangxi.html'
};

import { createApp } from 'vue';
import App from './jiangxi.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./jiangxi.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
